module.exports = __webpack_public_path__ + "static/media/fly0127.9a0fdf4c.webp";